var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('text-input',{attrs:{"hint":_vm.placeholder,"label":_vm.label,"value":_vm.value,"required":_vm.required,"pattern":"[0-9]*","inputmode":"numeric","maxlength":_vm.maxlength,"subhint":_vm.subhint,"validation-error":_vm.error},on:{"input":_vm.onInput,"click":function($event){return _vm.$emit('click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }